export default "__VITE_PUBLIC_ASSET__550041c7__"